import React, { useState, useRef, useEffect } from 'react';
import { Button } from '../button/Button';
import { Text } from './Navbar-text';
import './Navbar.css';
import { Link, useLocation } from "react-router-dom";
import { navGroups, NavGroup, NavItem } from './navGroups';
// import { GetToastieDialog } from '../get-toastie-dialog/get-toastie-dialog';

const logoTextSrc = `${process.env.PUBLIC_URL}/assets/toastie-text.svg`;

interface NavbarProps { }

const NavItemLink: React.FC<{ item: NavItem; onSelect: () => void }> = ({ item, onSelect }) => {
  const content = (
    <>
      <span className="nav-item-label">{item.label}</span>
      <span className="nav-item-description">{item.description}</span>
    </>
  );

  return item.external ? (
    <a href={item.to} target="_blank" rel="noopener noreferrer" className="nav-item" onClick={onSelect}>{content}</a>
  ) : (
    <Link to={item.to} className="nav-item" onClick={onSelect}>{content}</Link>
  );
};

const hamburgerIconSrc = `${process.env.PUBLIC_URL}/assets/hamburger-icon.png`;
const logoImageSrc = `${process.env.PUBLIC_URL}/assets/toastie-logo.png`;
const qr = `${process.env.PUBLIC_URL}/assets/appDownload/QR.png`;

export const Navbar: React.FC<NavbarProps> = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState<NavGroup['id'] | null>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setIsDialogOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleWaitlistClick = () => {
    setIsDialogOpen(!isDialogOpen);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close everything after picking an item. Blurring matters too: the dropdown also
  // opens on :focus-within, so the clicked link keeping focus would hold it open.
  const closeMenus = () => {
    setIsMenuOpen(false);
    setOpenGroup(null);
    (document.activeElement as HTMLElement | null)?.blur();
  };

  // Also close after any other navigation (e.g. browser back/forward)
  useEffect(() => {
    setIsMenuOpen(false);
    setOpenGroup(null);
  }, [location.pathname, location.hash]);

  // Close an open dropdown when clicking elsewhere (for touch devices)
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpenGroup(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className='hamburger-logo-container'>
        <button className="hamburger" onClick={toggleMenu}>
          <img id='hamburger-icon' src={hamburgerIconSrc} alt="Hamburger Icon" />
        </button>
        <div className="logo">
          <Link to="/">
            <img src={logoImageSrc} alt="Toastie Logo" />
          </Link>
          <Link to="/">
            <img id="logo-text" src={logoTextSrc} alt="Toastie" />
          </Link>
        {/* <Link to="/">
          <img src={logoImageSrc} alt="Toastie Logo" />
        </Link> */}
        </div>
      </div>
      <div className='links-button-container'>
        <div ref={menuRef} className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          {navGroups.map((group) => (
            <div
              key={group.id}
              className={`nav-group ${openGroup === group.id ? 'open' : ''}`}
              onMouseEnter={() => setOpenGroup(group.id)}
              onMouseLeave={() => setOpenGroup(null)}
            >
              <button
                className="nav-group-label"
                aria-expanded={openGroup === group.id}
                aria-controls={`nav-group-${group.id}`}
                onClick={() => setOpenGroup(openGroup === group.id ? null : group.id)}
              >
                {/* called as a function: react-icons' types don't match this project's React types as JSX */}
                {group.icon({ className: 'nav-group-icon', 'aria-hidden': true })}
                {group.label}
                <span className="nav-group-chevron" aria-hidden="true">▾</span>
              </button>
              <ul className="nav-dropdown" id={`nav-group-${group.id}`}>
                {group.items.map((item) => (
                  <li key={item.label}>
                    <NavItemLink item={item} onSelect={closeMenus} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <Button label={Text.buttonText} onClick={handleWaitlistClick} className="navbar-get-button" />
        <div ref={popupRef} className={`get-toastie ${isDialogOpen ? 'open' : ''}`}>
          <h4>Download</h4>
          <img
            src={qr}
            alt="Download the app"
            className="qr"
          />
        </div>
        {/* <GetToastieDialog
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
        /> */}
      </div>
    </nav>
  );
};